import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { SUPER_ADMIN_UPNS } from './auth.super-admins';
import { AccessControlService } from './services/access-control/access-control.service';

// Checks the hardcoded SUPER_ADMIN_UPNS list directly against the active MSAL account
// first — independent of AccessControlService/the backend, this is the lockout-safety
// fallback that protects the access-control admin page itself, so it must not depend on
// the system it's gating. Falls back to AccessControlService.isSuper() (hardcoded OR
// DB-granted Global Admin, per the backend's /me response) so Global Admins — who by
// definition depend on that system — can reach the page too.
@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {

  constructor(private authService: MsalService, private router: Router, private accessControl: AccessControlService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const activeAccount: AccountInfo | null = this.authService.instance.getActiveAccount();

    if (!activeAccount) {
      this.authService.loginRedirect();
      return false;
    }

    const userUpn = (activeAccount.idTokenClaims?.['upn'] as string) ||
                    (activeAccount.idTokenClaims?.['preferred_username'] as string) ||
                    (activeAccount.idTokenClaims?.['email'] as string) ||
                    activeAccount.username;

    if (userUpn && SUPER_ADMIN_UPNS.some(u => u.toLowerCase() === userUpn.toLowerCase())) {
      return true;
    }

    await this.accessControl.ready();
    if (this.accessControl.isSuper()) {
      return true;
    }

    this.router.navigate(['/unauthorized']);
    return false;
  }
}
